import { EAvailableBrokerFlow } from '../../repositories/newbuilding-search/entities/newbuilding_broker/NewbuildingBrokerSchema';
import { INewbuilding } from '../../types/newbuilding';
import { IApplicationState } from '../../types/redux';

export const getNewbuildingBrokerFlow = (
  state: IApplicationState,
  newbuilding: INewbuilding,
): EAvailableBrokerFlow | null => {
  if (state.config.isBrokerEnabled) {
    return newbuilding.newbuildingBroker?.availableBrokerFlow || null;
  }

  return null;
};
